import { AnnaError } from "@anna-money/anna-web-lib/utils";
import type { IdentiyFormValues } from "helpers/forms/au/identityTypes";
import { DirectorStore } from "services/director/directorStore";
import type { SumsubApplicationStore } from "services/sumsub/sumsubApplicationStore";

export enum IdentityStepEntity {
  DrivingLicenceStateOfIssue = "DrivingLicenceStateOfIssue",
}

export class IdentityStepStore {
  constructor(
    private readonly _directorStore: DirectorStore,
    protected readonly _sumsubApplicationStore: SumsubApplicationStore,
  ) {}

  async updateEntity(data: IdentiyFormValues, entity: IdentityStepEntity): Promise<void> {
    switch (entity) {
      case IdentityStepEntity.DrivingLicenceStateOfIssue:
        await this.updateDrivingLicenceStateOfIssue(data.drivingLicenceStateOfIssue);
    }
  }

  private async updateDrivingLicenceStateOfIssue(drivingLicenceStateOfIssue?: string): Promise<void> {
    if (!drivingLicenceStateOfIssue) {
      throw new AnnaError("No driving licence state of issue value");
    }

    await this._directorStore.updateDriversLicenceState(
      this._directorStore.getMainDirector().id,
      drivingLicenceStateOfIssue,
    );
    await this._sumsubApplicationStore.getSumsubApplication();
  }
}
